import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ApoderadoSnapshot } from '../../models/constitution-snapshot.model';
import { ConstitutionReadonlyFieldComponent } from '../shared/constitution-readonly-field.component';

@Component({
  selector: 'app-constitution-attorneys-readonly-detail',
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [CommonModule, ConstitutionReadonlyFieldComponent],
  templateUrl: './constitution-attorneys-readonly-detail.component.html',
  styleUrl: '../../../constitution-form/constitution-form.component.scss',
})
export class ConstitutionAttorneysReadonlyDetailComponent {
  apoderado = input.required<ApoderadoSnapshot>();
}
